import React from "react";
import { Link } from "react-router-dom";
import "./Religion.css";

/**
 * Religion:
 *  - Displays a grid of 4 “categories” 
 *    (Buddhism, Taoism, Christianity, Roman Catholic)
 *  - Each category link leads to a relevant page or lesson.
 *
 * This is analogous to your Science.js structure, 
 * but no “grade detection” is done here. 
 * Just showing 4 main links. 
 */
export default function Religion() {
  return (
    <div className="play2learn-religion">
      <h1 className="religion-title">Religion</h1>
      <p className="religion-description">
        Please select a category to explore:
      </p>

      <div className="religion-category-container">
        <Link to="/religion/buddhism" className="religion-category-card">
          Buddhism
        </Link>
        <Link to="/religion/taoism" className="religion-category-card">
          Taoism
        </Link>
        <Link to="/religion/christianity" className="religion-category-card">
          Christianity
        </Link>
        <Link to="/religion/romancatholic" className="religion-category-card">
          Roman Catholic
        </Link>
      </div>
    </div>
  );
}
